/* eslint-disable react/no-unknown-property */
// import external modules
import React from "react";
import {
  ChevronRight,
  LifeBuoy,
  FileText
} from "react-feather";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
// Styling
import "../../../../assets/scss/components/sidebar/sidemenu/sidemenu.scss";
// import internal(own) modules
import SideMenu from "../sidemenuHelper";
import { getMenuItems } from "./sidemenu.config";

const SideMenuContent = (props) => {
  const contributorData = useSelector((state) => state.contributor);
  const isAdmin = contributorData.role.indexOf("admin") !== -1;
  const menuItems = getMenuItems({ isAdmin, service: contributorData.servicoSelecionado });

  return (
    <SideMenu
      className="sidebar-content"
      toggleSidebarMenu={props.toggleSidebarMenu}
    >
      {menuItems.map((item) => {
        const Icon = item.icon;
        const isSingleItem = !item.items;

        return isSingleItem ? (
          <SideMenu.MenuSingleItem key={item.title}>
            {item.isVisible && <NavLink to={item.to} activeclassname="active">
              <i className="menu-icon">
                <Icon size={18} />
              </i>

              <span className="menu-item-text">{item.title}</span>
            </NavLink>}
          </SideMenu.MenuSingleItem>
        ) : (
          <SideMenu.MenuMultiItems
            key={item.title}
            name={item.title}
            Icon={<Icon size={18} />}
            ArrowRight={<ChevronRight size={16} />}
            collapsedSidebar={props.collapsedSidebar}
          >
            {item.items.map((item) => (
              <NavLink
                key={item.title}
                to={item.to}
                exact
                className="item"
                activeclassname="active"
              >
                <span className="menu-item-text">{item.title}</span>
              </NavLink>
            ))}
          </SideMenu.MenuMultiItems>
        );
      })}

      <SideMenu.MenuSingleItem>
        <a
          href="https://ayo.freshdesk.com/support/home"
          target="_blank"
          rel="noopener noreferrer"
          activeclassname="active"
        >
          <i className="menu-icon">
            <LifeBuoy size={18} />
          </i>
          <span className="menu-item-text">Suporte</span>
        </a>
      </SideMenu.MenuSingleItem>

      <SideMenu.MenuSingleItem>
        <a
          href="http://ayoapp.com.br/termos/termos-condicoes-clientes"
          target="_blank"
          rel="noopener noreferrer"
          activeclassname="active"
        >
          <i className="menu-icon">
            <FileText size={18} />
          </i>
          <span className="menu-item-text">Termos e condições</span>
        </a>
      </SideMenu.MenuSingleItem>
    </SideMenu>
  );
};

export default SideMenuContent;
